import { CourseType, UserType } from '../../../types'

export const getCoursePrice = (course?: CourseType, user?: UserType) => {
  if (!course?.price) {
    return 0
  }

  if (user?.stripeSubscriptionStatus === 'Active' && !user?.trial) {
    return (course.memberPrice || course.price) / 100
  }

  return course.price / 100
}
